module.exports = __webpack_public_path__ + "img/LSK-alt.0d7d3201.svg";